<div class="main">
  <div class="loading-shade" *ngIf="isLoading || isLoadingBarrierProblems || isLoadingTubingWearReports">
      <mat-spinner></mat-spinner>
  </div>
  <div class="section risks-alerts">
    <app-handover-detail-well-integrity-risks-alerts
      [handover]="handover" [readOnlyContent]="readOnlyContent" [isEngineerUser]= "isEngineerUser"
      (isLoading)="onBarrierProblemsLoading($event)" (sectionTouched)="onSectionTouched($event)" (hasPendingChanges)="onSectionHasPendingChangesBarrier($event)">
    </app-handover-detail-well-integrity-risks-alerts>
  </div>
  <div class="section handover-images">
    <div class="top">
        <h2>Esquema de Barreras</h2>

        <div clas="count">{{barriersSchemaImages.length + '/' + imageLimit + ' archivos'}}</div>

        <div class="attach" *ngIf="barriersSchemaImages.length < imageLimit">
          <button mat-button [disabled]="readOnlyContent || (isHO3 && !isEngineerUser)" (click)="attachBarriersSchema()">
            <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar esquema
          </button>
        </div>
    </div>

    <div class="grid">
        <div class="image" *ngFor="let image of barriersSchemaImages; index as i; first as isFirst">
            <div class="actions">
                <div class="button">
                    <button mat-icon-button *ngIf="!(readOnlyContent || (isHO3 && !isEngineerUser))" (click)="deleteBarriersSchema(image, i)">
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button> &nbsp;
                    <span class="legend" *ngIf="!(readOnlyContent || (isHO3 && !isEngineerUser))">Eliminar</span>
                </div>
                <div class="button">
                    <span class="legend">Ampliar</span>&nbsp;
                    <button mat-icon-button (click)="openBarriersSchema(image)">
          <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
        </button>
                </div>
            </div>
            <img src="{{dhoApiUrl}}/{{image.imagePath}}" alt="{{image.imageDescription}}" />
            <div class="description" *ngIf="image.imageDescription">
                {{image.imageDescription}}
            </div>
        </div>
    </div>
  </div>
  <div class="section barrier-problems">
    <app-handover-detail-well-integrity-barrier-element-issues
      [handover]="handover" [readOnlyContent]="readOnlyContent"
      (isLoading)="onBarrierProblemsLoading($event)" (sectionTouched)="onSectionTouched($event)" (hasPendingChanges)="onSectionHasPendingChangesBarrier($event)">
    </app-handover-detail-well-integrity-barrier-element-issues>
  </div>
  <div class="section tubing-wear">
    <app-handover-detail-well-integrity-tubing-wear
      [handoverId]="handover?.handoverId" [wellId]="handover?.wellId" [readOnlyContent]="readOnlyContent || (isHO3 && !isEngineerUser)"
      (isLoading)="onTubingWearLoading($event)" (sectionTouched)="onSectionTouched($event)" (hasPendingChanges)="onSectionHasPendingChangesTubing($event)">
    </app-handover-detail-well-integrity-tubing-wear>
  </div>
</div>